import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import authService from "../../services/auth.service";
import ToastComponent from "../Common/TaostComponent";
const ForgotPassword = (props) => {
  const navigate = useNavigate();
  const initialValues = {
    email: "",
  };
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email field is required."),
  });
  const onSubmit = (formValue) => {
    authService.forgotPassword(formValue).then((res) => {
      if (res.status !== 200) {
        ToastComponent(res.message, "error");
      } else {
        ToastComponent(res.message, "success");
        navigate("/");
      }
    });
  };
  return (
    <div className="middle-section">
      <div className="container">
        <div className="cms-section">
          <div className="heading">
            <h2>Forgot Password</h2>
          </div>
          <div className="whitebox">
            <div className="playerprofile-section">
              <div className="loginform">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({
                    errors,
                    handleChange,
                    values,
                    touched,
                    setFieldValue,
                  }) => (
                    <Form>
                      <div className="form-group">
                        <Field
                          name="email"
                          type="text"
                          placeholder="Email"
                          className="form-control"
                        />
                        {touched.email && errors.email && (
                          <span className="help-inline error">
                            {errors.email}
                          </span>
                        )}
                      </div>
                      <div className="text-center">
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
